import { Breadcrumbs, Button } from "@itandi/itandi-bb-ui";
import Link from "next/link";
import type React from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { Table } from "~/components/common/parts/table/Table";
import { TableBody } from "~/components/common/parts/table/TableBody";
import { TableHeader } from "~/components/common/parts/table/TableHeader";
import { TableRow } from "~/components/common/parts/table/TableRow";
import { useImportLogs } from "~/hooks/admin/useImportLogs";
import { importTypeLabels, isImportType } from "~/models/ImportLog";
import { PATH } from "~/pages/settings/imports";
import { getDownloadPath } from "~/utils/api/ImportLogErrorDownload";
import SettingStyles from "../../../../SettingStyle.module.scss";
import Styles from "./Page.module.scss";

type Props = {
	importLogId: number;
	importType: string;
};

export const Page: React.FC<Props> = ({ importType, importLogId }: Props) => {
	const { data: importLog } = useImportLogs().useShow(importLogId);

	if (importLog === null || !isImportType(importType)) {
		return null;
	}

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<div className={SettingStyles.BreadcrumbsBlock}>
					<Breadcrumbs
						items={[
							{ as: Link, href: PATH, label: "過去データ取込" },
							{
								as: Link,
								href: PATH,
								label: importTypeLabels[importType]
							},
							{ label: "エラーログ" }
						]}
					/>
				</div>
				<h2 className={SettingStyles.SettingTitle}>
					{importTypeLabels[importType]}の取込エラーログ
				</h2>
				<div className={Styles.DownloadButtonArea}>
					<Button
						height="small"
						onClick={() => window.open(getDownloadPath(importLogId))}
					>
						CSVダウンロード
					</Button>
				</div>
				<Table>
					<TableHeader>
						<th>行番号</th>
						<th>エラーキー</th>
						<th>エラー内容</th>
					</TableHeader>
					<TableBody>
						{importLog.importLogErrors.map((error) => (
							<TableRow key={error.id}>
								<td>{error.rowNum}</td>
								<td>{error.errorKey}</td>
								<td>{error.errorMessage}</td>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</ClientSettingLayout>
		</DefaultV2>
	);
};
